import * as _ from "underscore";

export const permissions = {
  free: {
    phrases: 10,
    definitions: 10,
    reviewSummaries: 1,
    chat: 0,
  },
  standard: {
    phrases: 4500,
    definitions: 2500,
    reviewSummaries: 200,
    chat: 2,
  },
  plus: {
    phrases: 9000,
    definitions: 5000,
    reviewSummaries: 400,
    chat: 200,
  },
};

export const plans = {
  // -- Current plans --
  free: {
    permissions: "free",
    months: 0,
    price: 0,
    default: true,
  },

  premiumPlusMonthly1: {
    permissions: "plus",
    months: 1,
    price: 15.0,
    default: true,
  },
  premiumPlusYearly1: {
    permissions: "plus",
    months: 12,
    price: 120.0,
    default: true,
  },

  premiumMonthly6: {
    permissions: "standard",
    months: 1,
    price: 6.0,
    default: true,
  },
  premiumYearly9: {
    permissions: "standard",
    months: 12,
    price: 48.0,
    default: true,
  },

  // -- Deprecated / non-default plans --
  premiumYearly10: {
    permissions: "standard",
    months: 12,
    price: 60.0,
  },
  premiumMonthly4: {
    permissions: "standard",
    months: 1,
    price: 4.0,
  },
  premiumMonthly5: {
    permissions: "standard",
    months: 1,
    price: 5.0,
  },
  premiumYearly8: {
    permissions: "standard",
    months: 12,
    price: 30.0,
  },
  premiumYearly7: {
    permissions: "standard",
    months: 12,
    price: 48.0,
  },
  premiumYearly6: {
    permissions: "standard",
    months: 12,
    price: 36.0,
  },
  premiumMonthly3: {
    permissions: "standard",
    months: 1,
    price: 3.0,
  },
  premiumYearly4: {
    permissions: "standard",
    months: 12,
    price: 24.0,
  },
  premiumYearly5: {
    permissions: "standard",
    months: 12,
    price: 36.0,
  },
  premiumLife2: {
    permissions: "standard",
    months: 1200,
    price: 150,
  },
  premiumYearly3: {
    permissions: "standard",
    months: 12,
    price: 29.99,
  },
  premiumLife: {
    permissions: "standard",
    months: 1200,
    price: 99.99,
  },
  premiumMonthly: {
    permissions: "standard",
    months: 3,
    price: 4.99,
  },
  premiumYearly2: {
    permissions: "standard",
    months: 12,
    price: 14.99,
  },
  standard: {
    permissions: "standard",
    // various months and price!
  },
  plus: {
    permissions: "plus",
    // various months and price!
  },
  freeForever: {
    permissions: "plus",
    months: 0,
    price: 0,
  },
  unsubscribed: {
    permissions: "free",
    months: 0,
    price: 0,
  },
  yearly1000: {
    permissions: "standard",
    months: 12,
    price: 10.0,
  },
  yearly999: {
    permissions: "standard",
    months: 12,
    price: 9.99,
  },
  premiumMonthly2: {
    permissions: "standard",
    months: 3,
    price: 9.99,
  },
};

const defaultPlans = {};
for (const [name, plan] of _.pairs(plans)) {
  if (plan.default) {
    defaultPlans[`${plan.permissions}-${plan.months}`] = {
      name,
      ...plan,
    };
  }
}

/**
 * @param {"standard" | "plus"} permissionsName
 * @param {number} months
 */
export const getDefaultPlan = (permissionsName, months) => {
  return defaultPlans[`${permissionsName}-${months}`];
};

const durations = {
  0: {
    renewDescription: "Don't Auto-Renew",
  },
  1: {
    renewDescription: "Monthly",
    periodString: "month",
  },
  3: {
    renewDescription: "Tri Monthly",
    periodString: "3 months",
  },
  12: {
    renewDescription: "Yearly",
    periodString: "year",
  },
};

_.each(plans, (plan, id) => {
  plan.id = id;
  _.extend(plan, durations[plan.months]);
});

export const getPlanFromMonths = (months) =>
  getPlanFromField("months", parseInt(months, 10));

/**
 * @returns {{
 *   permissions: "standard" | "plus" | "free";
 *   months: number;
 *   price: number;
 * }}
 */
export const getPlanFromPrice = (price) =>
  getPlanFromField("price", Number(price));

const getPlanFromField = (fieldName, fieldValue) => {
  let result;
  _.every(plans, (plan) => {
    if (plan[fieldName] === fieldValue) {
      result = plan;
      return false;
    }
    return true;
  });
  return result;
};

export const getPermissions = (plan) => permissions[plans[plan].permissions];
